import {
    startHTTPRequest
} from "../../../assets/js/common";
import {
    CFG_NODE_API_BASE
} from "../../../assets/js/config";
import { SUCCESS_CONTEST_LISTING_API } from "../../types";

const contest_listing_store = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.contest_listing_store) ? window.__ROI_STATE_DATA__.contest_listing_store : {
        contestList: [],
    }),
    actions: {
        fetchContestListApi: ({ commit }) => {
            let actionData = {
                method: "GET",
                url: `${CFG_NODE_API_BASE}match-data/get-contests`,
                can_append: false
            };
            return startHTTPRequest(actionData)
                .then((res) => {
                    commit(SUCCESS_CONTEST_LISTING_API, res);
                }).catch((err) => {
                    commit(SUCCESS_CONTEST_LISTING_API, {});
                })
        },
    },
    mutations: {
        [SUCCESS_CONTEST_LISTING_API]: (state, payload) => {
            let { contest_list } = payload;
            state.contestList = contest_list || [];
        }
    }
}

export default contest_listing_store;